export default __webpack_public_path__ + "static/media/MZ.3c00d1db.svg";